/** Accent colors for dashboard stat cards (icon tint). */
export const DASHBOARD_STAT_COLORS = {
  scrapers: "#3b82f6",
  extracted: "#7c3aed",
  success: "#10b981",
  errors: "#f59e0b",
} as const;

export const DASHBOARD_CHART_BAR_COLOR = "#7c3aed";
